import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import "firebase/firestore";
import "firebase/database";
import "firebase/functions";
// import 'firebase/messaging'; this is breaking in browser 9/14/2021

const config = {
  apiKey: process.env.REACT_APP_GREEKHOUSE_API_KEY,
  authDomain: process.env.REACT_APP_GREEKHOUSE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_GREEKHOUSE_DATABASE_URL,
  projectId: process.env.REACT_APP_GREEKHOUSE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_GREEKHOUSE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_GREEKHOUSE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_GREEKHOUSE_APP_ID,
  measurementId: process.env.REACT_APP_GREEKHOUSE_MEASUREMENT_ID,
};

// Initialize the default app
export const defaultApp = firebase.initializeApp(config);
export const auth = defaultApp.auth();
export const storage = defaultApp.storage();
export const database = defaultApp.database();
export const firestore = defaultApp.firestore();
export const functions = defaultApp.functions();
// export const messaging = defaultApp.messaging();

if (window.location.hostname === "localhost") {
  // auth.useEmulator("http://localhost:9099");
  // firestore.settings({
  //   host: "localhost:3000",
  //   ssl: false,
  // });
}
